import React from "react";
import { Route, Switch } from "react-router-dom";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";
import routes from "routes.js";

import logo from "assets/img/icon.png";

import SockJsClient from 'react-stomp';
import NotificationAlert from "react-notification-alert";
import axios from 'axios';

var ps;

var config = {
   crossdomain: true
};

var PostParameters = {
    "token":localStorage.getItem('token'),
    "type":"TEST",
    "data":[{
        "RANGE":{
            "last":30
        }
    }]
}

class Admin extends React.Component {
  HUB_ID = 2;
  constructor(props) {
    super(props);
    this.state = {
      mode: !!document.body.classList[0]?"Light":"Dark",
      backgroundColor: "green",
      sidebarOpened: document.documentElement.className.indexOf("nav-open") !== -1,
      store:{
        timestamp: 0,
        AmbientHumiditySensor:{key:"AmbientHumidity",values:[75,75,76,74,75,74,76],labels:["1:00pm","2:00pm","3:00pm","4:00pm","5:00pm","6:00pm","7:00pm", ], timestamp:[]},
        UVSensor:{key:"UV",values:[],labels:[], timestamp:[]},
        AmbientTempSensor:{key:"AmbientTemp",values:[-12, -11.9, -12.5, -12.9, -13.9, -14.6, -15.2, -15.0 ],labels:["1:00pm","2:00pm","3:00pm","4:00pm","5:00pm","6:00pm","7:00pm"], timestamp:[]},
        BarometerMoistureSensor:{key:"BarometerMoisture",values:[],labels:[], timestamp:[]},
        SoilTempSensor:{key:"SoilTemp",values:[-2, -1.9, -2.5, -2.9, -3.9, -4.6, -5.2, -5.0],labels:["1:00pm","2:00pm","3:00pm","4:00pm","5:00pm","6:00pm","7:00pm", ], timestamp:[]},
        SoilMoistureSensor:{key:"SoilMoisture",values:[43, 46, 44, 43, 40, 39, 36],labels:["1:00pm","2:00pm","3:00pm","4:00pm","5:00pm","6:00pm","7:00pm", ], timestamp:[]},
        BarometerTempSensor:{key:"BarometerTemp",values:[],labels:[], timestamp:[]},
        WindSpeedSensor:{key:"WindSpeed",values:[8,3,9,10,10,11,12,11],labels:["1:00pm","2:00pm","3:00pm","4:00pm","5:00pm","6:00pm","7:00pm", ], timestamp:[]},
        BarometerPressureSensor:{key:"BarometerPressure",values:[],labels:[], timestamp:[]}
      },
      notifications: [],
      dash:{
        one:"AmbientTemp",
        two:"WindSpeed",
        three:"SoilMoisture",
        four:"AmbientHumidity",
        five:"SoilTemp",
        six:"",
      },
    };
    this.saveVariable = this.saveVariable.bind(this);
    this.toggleMode = this.toggleMode.bind(this);
  }

  toggleMode = () => {
    var currentMode = this.state.mode;
    switch (currentMode) {
      case "Dark":
      document.body.classList.add("white-content");
      this.setState({
        mode: "Light"
      })
      break;
      default:
      document.body.classList.remove("white-content");
      this.setState({
        mode: "Dark"
      })
      break;
    }
  };

  getFullDate(UTCtime){
    const epoch = new Date(UTCtime);
    var day = this.formatDate(epoch);
    var time = this.formatTime(epoch);
    return epoch.toDateString() + " - " + time;
  }

  formatDate(date){
    return date.getFullYear() + "/" + this.fixTime(date.getMonth()+1) + "/" + this.fixTime(date.getDate());
  }

  formatTime(date){
    let hours = date.getHours();
    let ampm = hours > 12 ? "PM" : "AM";
    hours += hours > 12 ? -12 : 0;
    return hours + ":" + this.fixTime(date.getMinutes()) + " " + ampm;
  }

  round(num){
    return Math.round(num * 100) / 100;
  }

  fixTime(d){
    return ('0' + d).slice(-2);
  }

  generateNotification(msg){
      console.log(msg);
      // Format: {name, level, info, time}
      const notifications = this.state.notifications;
      var type = "primary";
      switch (msg.level) {
        case 1:
          type = "primary";
          break;
        case 2:
          type = "success";
          break;
        case 3:
          type = "danger";
          break;
        case 4:
          type = "warning";
          break;
        case 5:
          type = "info";
          break;
        default:
          break;
      }
      msg.level = type;
      notifications.push(msg);
      this.setState({
        notifications: notifications
      });

      var options = {
        place: "tr",
        message: (
          <div>
            <div><b>
                {msg.name}
            </b></div>
            <div>
                {msg.info}
            </div>
            <span>{this.getFullDate(msg.timeStamp)}</span>
          </div>
        ),
        type: msg.level,
        icon: "tim-icons icon-bell-55",
        autoDismiss: 20
      };
      this.refs.notificationAlert.notificationAlert(options);
      // this.notify(msg.content);
  }

  notify = message => {
    var type = "warning";
    var options = {
      place: "tr",
      message: (
        <div>
          <div>
              {message}
          </div>
        </div>
      ),
      type: type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 7
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  saveVariable(id, name) {
    this.setState({
      dash:{
        one:this.state.dash.one,
        two:this.state.dash.two,
        three:this.state.dash.three,
        four:this.state.dash.four,
        five:this.state.dash.five,
        six:this.state.dash.six,
        [id]:name
      }
    })
  }

  dateParser = (timestamp) => {
      return timestamp.split(' ')[1].slice(0,8);
  }

  round(num){
    return Math.round(num * 1000) / 1000;
  }

  pollServer(){
    // console.log("pollServer");
      axios.post(`http://localhost:8080/data`,PostParameters,config)
      .then(res => {
          var postreturns= res.data.data;

          console.log(postreturns)

          var AmbientHumiditySensor ={
            key:"AmbientHumidity" ,
            values: postreturns.AmbientHumidity.map(val => { return Number(this.round(val.value))}).reverse(),
            labels: postreturns.AmbientHumidity.map(val => { return this.dateParser(val.timestamp)}).reverse(),
          }
          var UVSensor ={
            key:"UV" ,
            values: postreturns.UV.map(val => { return Number(this.round(val.value))}).reverse(),
            labels: postreturns.UV.map(val => { return this.dateParser(val.timestamp)}).reverse(),
          }
          var AmbientTempSensor ={
            key:"AmbientTemp" ,
            values: postreturns.AmbientTemp.map(val => { return Number(this.round(val.value))}).reverse(),
            labels: postreturns.AmbientTemp.map(val => { return this.dateParser(val.timestamp)}).reverse(),
          }
          var BarometerMoistureSensor ={
            key:"BarometerMoisture" ,
            values: postreturns.BarometerMoisture.map(val => { return Number(this.round(val.value))}).reverse(),
            labels: postreturns.BarometerMoisture.map(val => { return this.dateParser(val.timestamp)}).reverse(),
          }
          var SoilTempSensor ={
            key:"SoilTemp" ,
            values: postreturns.SoilTemp.map(val => { return Number(this.round(val.value))}).reverse(),
            labels: postreturns.SoilTemp.map(val => { return this.dateParser(val.timestamp)}).reverse(),
          }
          var SoilMoistureSensor ={
            key:"SoilMoisture" ,
            values: postreturns.SoilMoisture.map(val => { return Number(this.round(val.value))}).reverse(),
            labels: postreturns.SoilMoisture.map(val => { return this.dateParser(val.timestamp)}).reverse(),
          }
          var BarometerTempSensor ={
            key:"BarometerTemp" ,
            values: postreturns.BarometerTemp.map(val => { return Number(this.round(val.value))}).reverse(),
            labels: postreturns.BarometerTemp.map(val => { return this.dateParser(val.timestamp)}).reverse(),
          }
          var WindSpeedSensor ={
            key:"WindSpeed" ,
            values: postreturns.WindSpeed.map(val => { return Number(this.round(val.value))}).reverse(),
            labels: postreturns.WindSpeed.map(val => { return this.dateParser(val.timestamp)}).reverse(),
          }
          var BarometerPressureSensor ={
            key:"BarometerPressure" ,
            values: postreturns.BarometerPressure.map(val => { return Number(this.round(val.value))}).reverse(),
            labels: postreturns.BarometerPressure.map(val => { return this.dateParser(val.timestamp)}).reverse(),
          }

          this.setState({
              store:{
                timestamp: this.state.store.timestamp +1 ,
                AmbientHumiditySensor: AmbientHumiditySensor,
                UVSensor: UVSensor,
                AmbientTempSensor: AmbientTempSensor,
                BarometerMoistureSensor: BarometerMoistureSensor,
                SoilTempSensor: SoilTempSensor,
                SoilMoistureSensor: SoilMoistureSensor,
                BarometerTempSensor: BarometerTempSensor,
                WindSpeedSensor: WindSpeedSensor,
                BarometerPressureSensor: BarometerPressureSensor
              }
          });


      })
  }

  componentDidMount() {
    this.pollServer();
    this.interval = setInterval(() => this.pollServer(), 30000);
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(this.refs.mainPanel, { suppressScrollX: true });
      let tables = document.querySelectorAll(".table-responsive");
      for (let i = 0; i < tables.length; i++) {
        ps = new PerfectScrollbar(tables[i]);
      }
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.documentElement.className += " perfect-scrollbar-off";
      document.documentElement.classList.remove("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      if (navigator.platform.indexOf("Win") > -1) {
        let tables = document.querySelectorAll(".table-responsive");
        for (let i = 0; i < tables.length; i++) {
          ps = new PerfectScrollbar(tables[i]);
        }
      }
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }
  // this function opens and closes the sidebar on small devices
  toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    this.setState({ sidebarOpened: !this.state.sidebarOpened });
  };
  getRoutes = routes => {
    return routes.map((prop, key) => {
        // change to "" to remove admin from URL
      if (prop.layout === "/user") {
        return (
          <Route
            path={prop.layout + prop.path}
            render={(props) => <prop.component{...props}
              store = {this.state.store}
              notifications={this.state.notifications}
              dash={this.state.dash}
              saveVariable={this.saveVariable}
              currentMode={this.state.mode}
            />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  handleBgClick = color => {
    this.setState({ backgroundColor: color });
  };
  getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  render() {
    return (
      <>
        <div className="react-notification-alert-container">
            <NotificationAlert ref="notificationAlert" />
            <SockJsClient
                url='http://localhost:8080/ws'
                topics={['/topics/public','/queue/message/']}
                onMessage={(msg) => {this.generateNotification(msg)}}
                onConnect={ () => { console.log("Socket Connected") } }
                ref={ (client) => { this.clientRef = client }} />
        </div>

        <div className="wrapper">
          <Sidebar
            {...this.props}
            routes={routes}
            bgColor={this.state.backgroundColor}
            logo={{
              text: "AgriBoost",
              imgSrc: logo
            }}
            toggleSidebar={this.toggleSidebar}
          />
          <div
            className="main-panel"
            ref="mainPanel"
            data={this.state.backgroundColor}
          >
            <AdminNavbar
              {...this.props}
              brandText={this.getBrandText(this.props.location.pathname)}
              toggleSidebar={this.toggleSidebar}
              sidebarOpened={this.state.sidebarOpened}
              currentMode={this.state.mode}
              toggleMode={this.toggleMode}
            />
            <Switch>{this.getRoutes(routes)}</Switch>
            {// we don't want the Footer to be rendered on map page
            this.props.location.pathname.indexOf("map") !== -1 ? null : (
              <Footer fluid />
            )}
          </div>
        </div>
      </>
    );
  }
}

export default Admin;
